import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/home/Hero';
import FeaturesSection from '../components/home/FeaturesSection';
import PricingSection from '../components/home/PricingSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import CTASection from '../components/ui/CTASection';

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>rAIn IDX | Smarter MLS Integration for Real Estate Agents</title>
        <meta
          name="description"
          content="Empower your real estate brand with beautifully embedded listings, SEO-optimized IDX pages, and automated lead capture. Built for modern agents and teams."
        />
        <link rel="canonical" href="https://idx.rainautomation.com/" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "rAIn Automation IDX",
              "url": "https://idx.rainautomation.com",
              "logo": "https://idx.rainautomation.com/rain_idx_logo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "email": "support@rainautomation.com",
                "contactType": "Customer Support",
                "areaServed": "US",
                "availableLanguage": "English"
              },
              "sameAs": [
                "https://www.facebook.com/rainautomation",
                "https://www.instagram.com/rainautomation",
                "https://www.linkedin.com/company/rainautomation"
              ]
            }
          `}
        </script>
      </Helmet>

      <div className="home-page">

        <Hero />

        <FeaturesSection />
        <PricingSection />
        <TestimonialsSection />

        <CTASection
          title="Smarter IDX. Better Results."
          subtitle="Join modern agents boosting their visibility and closing more deals with rAIn IDX."
          primaryButtonText="Get Started"
          secondaryButtonText="Book a Demo"
          primaryButtonTo="/contact"
          secondaryButtonTo="/contact"
          background="light"
        />

      </div>
    </>
  );
};

export default HomePage;